document.addEventListener('DOMContentLoaded', () => {
  // Modal de tienda física (autocontenido: esta página usa un layout
  // mínimo sin global.js, no hay modal-dialog/modal-opener disponibles).
  // Sin tracking custom en esta página por decisión de Miguel (2026-08-24):
  // solo el tag base (GTM + lo que Shopify inyecta vía content_for_header).
  const modal = document.querySelector('[data-linkbio-modal]');
  const openButton = document.querySelector('[data-linkbio-store]');
  if (!modal || !openButton) return;

  const open = () => {
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  };

  openButton.addEventListener('click', open);
  modal.querySelectorAll('[data-linkbio-modal-close]').forEach((el) => {
    el.addEventListener('click', close);
  });
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
  });
});
